import { NgTemplateOutlet } from '@angular/common';
import { Component, input, TemplateRef } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { AdminTableColumn } from './admin-table-column.interface';

@Component({
  selector: 'app-admin-data-table',
  standalone: true,
  imports: [TranslatePipe, NgTemplateOutlet],
  templateUrl: './admin-data-table.component.html',
  styleUrl: './admin-data-table.component.scss',
})
export class AdminDataTableComponent<TRow = unknown> {
  columns = input.required<AdminTableColumn[]>();
  rows = input.required<TRow[]>();
  rowTemplate = input.required<TemplateRef<{ $implicit: TRow }>>();
  trackByProp = input<(row: TRow) => unknown>((row) => row as object);

  /** When set, hides the table below the mobile breakpoint (pair with a mobile card layout). */
  variant = input<'default' | 'desktop-only'>('default');

  trackRow(row: TRow): unknown {
    return this.trackByProp()(row);
  }
}
